<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              <div class="row">
                <div class="col col-md-12">
                  <pr-input-column
                    label="Frais d’entrée (hors prime d’émission)"
                    [derrors]="derrors"
                  >
                    <input
                      formControlName="fees"
                      type="number"
                      min="0"
                      max="100"
                      fraction="2"
                    />
                    <i>%</i>
                  </pr-input-column>
                </div>
              </div>
              <div class="row">
                <div class="col col-md-12">
                  <pr-input-column
                    label="Taux de commission partenaire (Honoraires de distribution)"
                    [derrors]="derrors"
                  >
                    <input
                      formControlName="distributionFees"
                      type="number"
                      min="0"
                      max="100"
                      fraction="2"
                      disabled="true"
                    />
                    <i>%</i>
                  </pr-input-column>
                </div>
              </div>
              <div class="row">
                <div class="col col-md-12">
                  <pr-input-column
                    label="Commission totale"
                    [derrors]="derrors"
                  >
                    <input
                      [value]="
                        form
                          .get('products')
                          .controls[0].get('parameters')
                          .get('fees').value +
                        form
                          .get('products')
                          .controls[0].get('parameters')
                          .get('distributionFees').value
                      "
                      type="number"
                      fraction="2"
                      disabled="true"
                    />
                    <i>%</i>
                  </pr-input-column>
                </div>
              </div>
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
